import { render, staticRenderFns } from "./listini-med.vue?vue&type=template&id=88ee7e7a"
import script from "./listini-med.vue?vue&type=script&lang=js"
export * from "./listini-med.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports